/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Vekn_Merge_DescriptionInputs */



/**
* | output |
* | --- |
* | "Find the duplicate account for {name}. The two will be combined into a single profile." |
*
* @param {Vekn_Merge_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_description = /** @type {((inputs: Vekn_Merge_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Trouvez le compte en double de ${i?.name}. Les deux seront réunis en un seul profil.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Encuentre la cuenta duplicada de ${i?.name}. Ambas se combinarán en un único perfil.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Encontre a conta duplicada de ${i?.name}. As duas serão combinadas em um único perfil.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Trova l'account duplicato di ${i?.name}. I due verranno uniti in un unico profilo.`)
	return /** @type {LocalizedString} */ (`Find the duplicate account for ${i?.name}. The two will be combined into a single profile.`)
});